import React, { useState } from "react";
import "./CarCard.css";

export interface Car {
  id: number;
  make: string;
  model: string;
  trim: string;
  location: string;
  cost: number;
  mileage: number;
  registration: string;
  images: string[];
  detailsUrl: string;
  insuranceGroup: number;
  isCarSold: boolean;
}

interface Props {
  car: Car;
  favorites: number[];
  setFavorites: React.Dispatch<React.SetStateAction<number[]>>;
  showCarIds: boolean;
}

const CarCard: React.FC<Props> = ({ car, favorites, setFavorites, showCarIds }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalSrc, setModalSrc] = useState("");
  const [limitModalOpen, setLimitModalOpen] = useState(false);

  const  HIGH_MILEAGE = 58000;

  const openModal = (src: string) => {
    setModalSrc(src);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalSrc("");
  };

  const isFavorite =
    favorites && favorites.length > 0 && favorites.includes(car.id);

  // const [isFavorite, setIsFavorite] = useState(() => {
  //   const favorites = JSON.parse(localStorage.getItem("favorites") || "{}");
  //   return !!favorites[car.id];
  // });

  // const toggleFavorite = () => {
  //   const favorites = JSON.parse(localStorage.getItem("favorites") || "{}");
  //   if (isFavorite) {
  //     delete favorites[car.id];
  //   } else {
  //     favorites[car.id] = true;
  //   }
  //   localStorage.setItem("favorites", JSON.stringify(favorites));
  //   setIsFavorite(!isFavorite);
  // };

  const toggleFavorite = () => {
    let updatedFavorites = [...favorites];

    if (isFavorite) {
      updatedFavorites = updatedFavorites.filter((id) => id !== car.id);
    } else {
      if (updatedFavorites.length >= 5) {
        setLimitModalOpen(true);
        return;
      }
      updatedFavorites.push(car.id);
    }

    localStorage.setItem("favorites", JSON.stringify(updatedFavorites));
    setFavorites(updatedFavorites);
  };

  // if (isFavorite) {
  //   delete favorites[car.id];
  //   setIsFavorite(false);
  // } else {
  //   const favoriteCount = Object.keys(favorites).length;
  //   if (favoriteCount >= 5) {
  //     setLimitModalOpen(true);
  //     return;
  //   }
  //   favorites[car.id] = true;
  //   setIsFavorite(true);
  // }

  //   localStorage.setItem("favorites", JSON.stringify(favorites));
  // };

  const getMileageStatus = (mileage: number, isSold: boolean): string => {
    if (mileage > HIGH_MILEAGE) {
      return isSold
        ? "is-dark has-text-grey-lighter"
        : "is-danger has-text-white-bis"; // is-light";
    } else if (mileage > 40000) {
      return isSold
        ? "is-dark has-text-grey-lighter"
        : "is-warning has-text-grey-darker"; //  is-light";
    } else {
      return isSold
        ? "is-dark has-text-grey-lighter"
        : "has-background-primary has-text-black-ter"; //  is-light";
    }
  };

  const returnCarSoldClassName = car.isCarSold ? "car-sold" : "";

  const returnMileageHighClassName = !car.isCarSold && car.mileage > HIGH_MILEAGE ? "car-sold" : "";
  
  const isCarMilageHigh = !car.isCarSold && car.mileage > HIGH_MILEAGE;



  const returnCarSoldInsuranceClassName = (carSold: boolean): string =>
    carSold ? "is-dark has-text-grey-lighter" : "is-link";

  const carId = showCarIds ? `(${car.id})` : '';

  return (
    <div className="column is-one-third">
      <div className={`card car-card ${returnCarSoldClassName} ${returnMileageHighClassName}`}>
        {car.isCarSold && (
          <div className="item-sold">
            <div className="tag is-black is-medium has-text-warning">SOLD</div>
          </div>
        )}

        {isCarMilageHigh && (
          <div className="item-sold">
            <div className="tag is-black  is-medium has-text-warning">HIGH MILEAGE</div>
          </div>
        )}

        <div className="card-image">
          <div className="columns is-mobile is-gapless car-thumbnails">
            {car.images.map((img, index) => {
              const imageClassName: string = img.includes("front")
                ? "first-image"
                : "last-image";
              return (
                <div className="column" key={index}>
                  <figure className="image is-4by3">
                    <img
                      src={`images/${img}`}
                      alt={`${car.make} ${car.model} - ${car.trim}`}
                      className={`thumbnail ${imageClassName}`}
                      onClick={() => openModal(`images/${img}`)}
                    />
                  </figure>
                </div>
              );
            })}
          </div>
        </div>

        <div className="card-content">
          <p className="title is-5">
            {car.make} {car.model} - {car.trim}
          </p>

          <hr />
          <div className="columns">
            <div className="column is-three-fifths">
              <p className="is-size-4">
                <strong>{car.registration}</strong> {carId}
              </p>
            </div>
            <div className="column">
              <p
                className={`tag ${getMileageStatus(
                  car.mileage,
                  car.isCarSold
                )}`}
              >
                {car.mileage} miles
              </p>
              <p className={`tag ${returnCarSoldInsuranceClassName(car.isCarSold)} mt-2`}>
                <span className="text-micro">Insurance group &nbsp;</span>{" "}
                {car.insuranceGroup}
              </p>
            </div>
          </div>

          <div className="columns">
            <div className="column">
              <p className="is-size-4">&pound;{car.cost}</p>
            </div>
            <div className="column has-text-right">
              <p className="is-size-6 ">Location: {car.location}</p>
            </div>
          </div>
        </div>

        <footer className="card-footer custom-footer">
          <div
            className="card-footer-item is-flex is-justify-content-space-between is-align-items-center"
            style={{ width: "100%" }}
          >
            <a
              href={car.detailsUrl}
              className="view-details"
              target="_blank"
              rel="noreferrer"
            >
              View Details
            </a>
            <div className="favorite-toggle" onClick={toggleFavorite}>
              <button className="button is-small is-rounded">
                <span className="icon is-small">
                  <i
                    className="fas fa-heart"
                    style={{
                      color: isFavorite ? "red" : "#CCCCCC",
                      cursor: "pointer",
                      fontSize: "1.2rem",
                      transition: "color 0.3s ease",
                    }}
                    title={
                      isFavorite ? "Remove from favorites" : "Add to favorites"
                    }
                  ></i>
                </span>
              </button>
            </div>
          </div>
        </footer>
      </div>

      {modalOpen && (
        <div className="modal is-active">
          <div className="modal-background" onClick={closeModal}></div>
          <div className="modal-content">
            <p className="image">
              <img src={modalSrc} alt="Large view" />
            </p>
          </div>
          <button
            className="modal-close is-large"
            aria-label="close"
            onClick={closeModal}
          ></button>
        </div>
      )}

      {limitModalOpen && (
        <div className="modal is-active">
          <div
            className="modal-background"
            onClick={() => setLimitModalOpen(false)}
          ></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title">Limit Reached</p>
              <button
                className="delete"
                aria-label="close"
                onClick={() => setLimitModalOpen(false)}
              ></button>
            </header>
            <section className="modal-card-body">
              You can only select up to 5 favourites. Please remove one before
              adding another.
            </section>
            <footer className="modal-card-foot is-justify-content-flex-end">
              <button
                className="button is-primary"
                onClick={() => setLimitModalOpen(false)}
              >
                OK
              </button>
            </footer>
          </div>
        </div>
      )}
    </div>
  );
};

export default CarCard;
